export default __webpack_public_path__ + "static/card-app-6d41ec922f86711627cee55f3700becf.svg";